import { useFormikContext } from "formik";
import { getShape, updateStringArray } from "../../Helpers/FormikUpdateFunctions";
import { metaobject } from "../../Helpers/WindowHelpers";
import ProductInput from "../Fields/ProductInput";
import UpsellPackage from "../Fields/UpsellPackage";
import Heading from "../Heading";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";
import PackageInterface from "../../Interfaces/PackageInterface";
import FilterButton from "../Fields/FilterButton";
import ProductInterface from "../../Interfaces/ProductInterface";
import VariantInterface from "../../Interfaces/VariantInterface";

interface Step5Interface {

}

const Step5 = ({ }: Step5Interface) => {
    const context = useFormikContext<any>();
    // TODO: implement shape specific upgrades/accessories
    const currentShape = getShape(context.values?.shape);
    const filterEmpty = context.values?.upgrade_filter?.length <= 0;    
    const upgradesAndAccessories = [
        ...metaobject.upgrades,
        ...metaobject.accessories,
        ...(currentShape?.accessories ?? []),
        ...(currentShape?.upgrades ?? []),
    ];

    const isVariantAvailable = (variant: VariantInterface) => 
        isVariantAvailableById(variant.id);

    const isVariantAvailableById = (variaintId: string) =>
        upgradesAndAccessories.some(product => product.variants.find(vari => vari.id === variaintId)?.available || false) || false;

    const activeUpsellPackages = metaobject.upgrades_and_accessories_packages.filter((item) => areAllPackageVariantsAvailable(item));

    function areAllPackageVariantsAvailable(upsellPackage: PackageInterface) {
        if(upsellPackage.variants?.length <= 0) return false;
        let available = true;
        for(const variant of upsellPackage.variants) {
            console.log(variant.id)
            if(!isVariantAvailable(variant)) {
                available = false;
            }
        }
        return available;
    }

    const activeUpgrades = metaobject.upgrades.filter((item) => availableUpgrades(item));
    const activeAccessories = metaobject.accessories.filter((item) => availableUpgrades(item))
    function availableUpgrades(product: ProductInterface) {
        return product.variants.some((variant: VariantInterface) => {
            const associatedVariants = variant?.metafields?.custom?.associated_variants ?? [];
            if(associatedVariants.length == 0) return true;
            const retVal = associatedVariants.every((id) => isVariantAvailableById(id.toString()));
            return retVal;
        });
    }

    function ProductInFilter(product: ProductInterface) {
        return (product.metafields?.custom?.upgrade_sort_options as string[])?.some((option) => 
            context.values?.upgrade_filter?.some((filter: string) => filter.toLowerCase() == option.toLowerCase()))
    }

    return (
        <>
            {activeUpsellPackages.length > 0 &&
                <>
                    <Heading
                        level={4}
                        text={"Featured Package"}
                    />
                    <div className="upsell-packages">
                        <Swiper
                            autoHeight={true}
                            keyboard={true}
                            slidesPerView={activeUpsellPackages.length > 1 ? 1.33 : 1}
                            className="gap-20"
                        >
                            {activeUpsellPackages.map((item) =>
                                <SwiperSlide className="height--100">
                                    <UpsellPackage
                                        upsellPackage={item}
                                        step={5}
                                    >
                                    </UpsellPackage>
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </div>
                </>
            }
            {metaobject.upgrades_and_accessories_sort_options?.length >= 1 &&
                <div className="d--flex flex-wrap--wrap gap-10">
                    <FilterButton 
                        label="All"
                        active={filterEmpty}
                        onClick={() => context.setFieldValue('upgrade_filter', [])}
                    />
                    {metaobject.upgrades_and_accessories_sort_options.map((option) => 
                    <FilterButton 
                        label={option}
                        active={context.values?.upgrade_filter?.some((val: string) => val == option.toLowerCase())} 
                        onClick={() => updateStringArray('upgrade_filter', option, context)} />)}
                </div>}
            {metaobject.upgrades.length > 0 &&
                <>
                    <Heading
                        level={4}
                        text={metaobject.text.upgrades_heading}
                    />
                    <div className={`card-product__list grid grid--sm`}>
                        {activeUpgrades.filter((item) => filterEmpty || ProductInFilter(item)).map((item, index) => (
                            <ProductInput
                                key={index}
                                product={item}
                                name="upgrades"
                                step={5}
                            >
                            </ProductInput>
                        ))}
                        {currentShape.upgrades.filter((item) => filterEmpty || ProductInFilter(item)).map((item, index) =>
                            <ProductInput
                                key={index}
                                product={item}
                                name="upgrades"
                                step={5}
                            >
                            </ProductInput>
                        )}
                    </div>
                </>
            }
            {metaobject.accessories.length > 0 &&
                <>
                    <Heading
                        level={4}
                        text={metaobject.text.accessories_heading}
                    />
                    <div className={`card-product__list grid grid--sm`}>
                        {activeAccessories.filter((item) => filterEmpty || ProductInFilter(item)).map((item, index) => (
                            <ProductInput
                                key={index}
                                product={item}
                                name="accessories"
                                step={5}
                            >
                            </ProductInput>
                        ))}
                        {currentShape.accessories.filter((item) => filterEmpty || ProductInFilter(item)).map((item, index) =>
                            <ProductInput
                                key={index}
                                product={item}
                                name="upgrades"
                                step={5}
                            >
                            </ProductInput>
                        )}
                    </div>
                </>
            }
        </>
    );
}

export default Step5;